import { useLocation } from 'react-router-dom';
import { CardStyle } from '../styles/card';
import { PropConfig } from '../types/EntityConfig';
import { CustomInput } from './CustomInput';
import FormButtons from './FormButtons';
import FormHeader from './FormHeader';


export default function Form({ form,
  patchData,
  isNewEntity,
  submitData,
  tableConfigs,
  setEditable,
  idProp,
  entityName,
  setIsOpen,
  isCopy,
  onCancel
}: any) {

  const location = useLocation();
  const currentRoute = location.pathname;

  const buildGetterFunction = (tc: any) => {

    if (tc.options?.triggeredGetter && form.state[tc.options?.triggerParam]) {
      return () => form.state[tc.options.triggerParam] ? tc.options.triggeredGetter(form.state[tc.options.triggerParam].id) : () => { console.log("Unable to fetch "); return null }
    } else if (tc.options?.routeBasedGetter && currentRoute) {
      const routes = tc.options.routeParams.map((rp: any) => currentRoute[rp])
      return () => tc.options?.routeBasedGetter(...routes);
    }

    return tc.options?.getter;
  }


  return (
    <>
      <FormHeader
        isCopy={isCopy}
        isNewEntity={isNewEntity}
        entityName={entityName}
        form={form}
        idProp={idProp} />

      <form style={{ ...CardStyle, marginBottom: 10 }}>



        <div>

          {form ? tableConfigs
            .filter((tc: PropConfig) => !tc.nonEditable)
            .filter((tc: PropConfig) => tc.conditional ? tc.conditional(form.state) : true)
            .map((tc: PropConfig, i: number) => {
              return (
                <div >
                  <CustomInput
                    inputConfiguration={tc}
                    getter={buildGetterFunction(tc)}
                    form={form}
                  />
                </div>)
            }) : null}
        </div>


        <FormButtons
          isNewEntity={isNewEntity}
          submitData={submitData}
          onCancel={onCancel}
          patchData={patchData}
          isCopy={isCopy}
          setIsOpen={setIsOpen}
          setEditable={setEditable}
        />

      </form>

    </>

  )


}